import React from "react";
import { Form, Button, Col, Container } from "react-bootstrap";

function AdditionalInformation(props) {
  const back = (e) => {
    e.preventDefault();
    props.prevStep();
  };

  const saveAndContinue = (e) => {
    e.preventDefault();
    props.nextStep();
  };

  return (
    <Container>
      <br></br>
      <h3 className="mt-2">Additional Information</h3>
      <hr />
      <Form>
        <div className="well-test-form-body">
          <Form.Group as={Col} controlId="formNotes">
            <Form.Label>Well Test Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              defaultValue={props.inputValues.notes}
              name="notes"
              required
              onChange={props.handleChange}
            />
          </Form.Group>
        </div>
        <Button variant="primary" onClick={back}>
          Back
        </Button>{" "}
        <Button
          variant="primary"
          className="well-test-next-btn"
          onClick={saveAndContinue}
        >
          Next
        </Button>
      </Form>
    </Container>
  );
}

export default AdditionalInformation;
